import React from "react";
import { useStatusBar } from "../header/hooks/useStatusBar";
import {  Container } from "./styles";

function SideBar() {
  const { handleCloseBar } = useStatusBar();

  return (
    <>
      <Container>
        <nav>
          <ul>
            <li>
              <button onClick={() => handleCloseBar("/")}>HOME</button>
            </li>
            <li>
              <button onClick={() => handleCloseBar("about")}>SOBRE</button>
            </li>
            <li>
              <button onClick={() => handleCloseBar("iniciativas")}>
                INICIATIVAS
              </button>
            </li>
            <li>
              <button onClick={() => handleCloseBar("help")}>
                COMO AJUDAR
              </button>
            </li>
            <li>
              <button onClick={() => handleCloseBar("/eventos")}>
                EVENTOS
              </button>
            </li>
            <li>
              <button onClick={() => handleCloseBar("/doacao")} className="button-doar">DOAR</button>
            </li>
          </ul>
        </nav>
      </Container>
    </>
  );
}

export { SideBar };
